import { BasicModalContext } from 'app/domain/basic-modal-context';

export class SmsModalContext extends BasicModalContext {
  constructor() {
    super();
    this.class = ' no-margin';
    this.ignoreBackdropClick = false;
  }
}
